import React from 'react';
import { Button } from './common/Button';
import { CheckIcon } from 'lucide-react';
export function SplitSection() {
  const shopperBenefits = ['Automatic rewards at local businesses', 'No apps to open when shopping', 'Discover new local favorites', 'Special perks for loyal customers', 'Share with friends for bonus points'];
  const merchantBenefits = ['No hardware or special equipment needed', 'Works with your existing payment system', 'Detailed customer insights dashboard', 'Customizable reward programs', 'Increase repeat customer visits'];
  return <section className="py-16 bg-[#f0ebff]" data-id="element-415">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-416">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-417">
          {/* Shoppers Side */}
          <div className="bg-white rounded-2xl shadow-sm p-8 hover:shadow-md transition-shadow duration-200" data-id="element-418">
            <div className="mb-6" data-id="element-419">
              <h3 className="text-2xl font-bold mb-4" data-id="element-420">For Shoppers</h3>
              <div className="h-1 w-12 bg-[#A020F0]" data-id="element-421"></div>
            </div>
            <ul className="space-y-3 mb-8" data-id="element-422">
              {shopperBenefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-423">
                  <div className="bg-[#A020F0] rounded-full p-1 mr-3 mt-0.5" data-id="element-424">
                    <CheckIcon className="h-4 w-4 text-white" data-id="element-425" />
                  </div>
                  <span data-id="element-426">{benefit}</span>
                </li>)}
            </ul>
            <Button variant="primary" size="lg" href="https://kraya.live" onClick={e => {
            e.preventDefault();
            window.open('https://kraya.live', '_blank');
          }} data-id="element-427">
              Join Waitlist
            </Button>
          </div>
          {/* Merchants Side */}
          <div id="merchants" className="bg-white rounded-2xl shadow-sm p-8 hover:shadow-md transition-shadow duration-200" data-id="element-428">
            <div className="mb-6" data-id="element-429">
              <h3 className="text-2xl font-bold mb-4" data-id="element-430">For Merchants</h3>
              <div className="h-1 w-12 bg-[#A020F0]" data-id="element-431"></div>
            </div>
            <ul className="space-y-3 mb-8" data-id="element-432">
              {merchantBenefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-433">
                  <div className="bg-[#A020F0] rounded-full p-1 mr-3 mt-0.5" data-id="element-434">
                    <CheckIcon className="h-4 w-4 text-white" data-id="element-435" />
                  </div>
                  <span data-id="element-436">{benefit}</span>
                </li>)}
            </ul>
            <Button variant="secondary" size="lg" href="https://kraya.shop/" data-id="element-437">
              Partner With Us
            </Button>
          </div>
        </div>
      </div>
    </section>;
}